import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getCustomers } from 'app/entities/customer/customer.reducer';
import { getEntities as getDeals } from 'app/entities/deal/deal.reducer';
import { UserDealStatus } from 'app/shared/model/enumerations/user-deal-status.model';
import { createEntity, getEntity, reset, updateEntity } from './user-deals.reducer';

export const UserDealsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const customers = useAppSelector(state => state.customer.entities);
  const deals = useAppSelector(state => state.deal.entities);
  const userDealsEntity = useAppSelector(state => state.userDeals.entity);
  const loading = useAppSelector(state => state.userDeals.loading);
  const updating = useAppSelector(state => state.userDeals.updating);
  const updateSuccess = useAppSelector(state => state.userDeals.updateSuccess);
  const userDealStatusValues = Object.keys(UserDealStatus);

  const handleClose = () => {
    navigate(`/user-deals${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getCustomers({}));
    dispatch(getDeals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.createdAt = convertDateTimeToServer(values.createdAt);
    values.updatedAt = convertDateTimeToServer(values.updatedAt);

    const entity = {
      ...userDealsEntity,
      ...values,
      customer: customers.find(it => it.id.toString() === values.customer?.toString()),
      deal: deals.find(it => it.id.toString() === values.deal?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          createdAt: displayDefaultDateTime(),
          updatedAt: displayDefaultDateTime(),
        }
      : {
          status: 'PENDING',
          ...userDealsEntity,
          createdAt: convertDateTimeFromServer(userDealsEntity.createdAt),
          updatedAt: convertDateTimeFromServer(userDealsEntity.updatedAt),
          customer: userDealsEntity?.customer?.id,
          deal: userDealsEntity?.deal?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tycheApp.userDeals.home.createOrEditLabel" data-cy="UserDealsCreateUpdateHeading">
            <Translate contentKey="tycheApp.userDeals.home.createOrEditLabel">Create or edit a UserDeals</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="user-deals-id"
                  label={translate('tycheApp.userDeals.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tycheApp.userDeals.customerId')}
                id="user-deals-customerId"
                name="customerId"
                data-cy="customerId"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.userDeals.status')}
                id="user-deals-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {userDealStatusValues.map(userDealStatus => (
                  <option value={userDealStatus} key={userDealStatus}>
                    {translate(`tycheApp.UserDealStatus.${userDealStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tycheApp.userDeals.createdAt')}
                id="user-deals-createdAt"
                name="createdAt"
                data-cy="createdAt"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tycheApp.userDeals.updatedAt')}
                id="user-deals-updatedAt"
                name="updatedAt"
                data-cy="updatedAt"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tycheApp.userDeals.expired')}
                id="user-deals-expired"
                name="expired"
                data-cy="expired"
                check
                type="checkbox"
              />
              <ValidatedField
                id="user-deals-customer"
                name="customer"
                data-cy="customer"
                label={translate('tycheApp.userDeals.customer')}
                type="select"
              >
                <option value="" key="0" />
                {customers
                  ? customers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField id="user-deals-deal" name="deal" data-cy="deal" label={translate('tycheApp.userDeals.deal')} type="select">
                <option value="" key="0" />
                {deals
                  ? deals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/user-deals" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default UserDealsUpdate;
